export function setTitleForIframe(iframe: HTMLIFrameElement) {
  const title = iframe.contentDocument?.querySelector("head title")?.textContent;
  const hasAuthoredTitle = iframe.getAttribute("title");

  if (title?.length && !hasAuthoredTitle) {
    iframe.setAttribute("title", title.trim());
  }
}
